import configJson from "../config.json";

/**
 * ConfigAdapter - Compatibilidade com config do integrar-skin
 * Mapeia o config.json do manager-cob para formato esperado pelos componentes importados
 */

const config = {
    development: {
        url: configJson.url_integrar.replace(/\/$/, ""), // Remove trailing slash
    },
    production: {
        url: configJson.url_integrar.replace(/\/$/, ""),
    },
    local: {
        url: configJson.url_integrar.replace(/\/$/, ""),
    },
};

// Detecta ambiente baseado no hostname
const env =
    window.location.hostname === "localhost"
        ? "local"
        : window.location.hostname.includes("preprod")
          ? "development"
          : "production";

/**
 * getBasicAuthHeaders - Gera headers com autenticação Basic Auth
 * Usada para requisições às APIs importadas do integrar-skin
 *
 * @returns {Object} Headers com Authorization Basic Auth
 * @example
 * const headers = getBasicAuthHeaders();
 * fetch(url, {
 *   method: 'GET',
 *   headers: new Headers(headers)
 * });
 */
export const getBasicAuthHeaders = () => {
    // Credenciais ofuscadas em base64
    const u = atob("Y29icmFuY2E=");
    const p = atob("Q0c1RThqckNQNg==");
    const basicAuth = "Basic " + btoa(u + ":" + p);

    return {
        Authorization: basicAuth,
        "Content-Type": "application/json",
    };
};

export default config;
